import { render } from "./OrderExpensesList.vue?vue&type=template&id=938e72fc&scoped=true"
import script from "./OrderExpensesList.vue?vue&type=script&lang=js"
export * from "./OrderExpensesList.vue?vue&type=script&lang=js"

import "./OrderExpensesList.vue?vue&type=style&index=0&id=938e72fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-938e72fc"]])

export default __exports__